export const Routes = {
  Home: '/',
  About: '/about',
  Art: '/art',
  Things: '/things',
  Thoughts: '/thoughts',
  ThoughtInfo: '/thoughts/info/:id',
  Music: '/music',
  ThoughtStandalone: '/thoughts/:id/view',
  ArtPublication: '/art/publication',
  Contact: '/contact',
  NotFound: '/404',
};
